import { Link } from 'react-router-dom';



export default function Vision() {
  return (

    <div className='relative flex items-center justify-start w-full vision-background bottom-[22px] mt-16'>
      <div className='relative z-10 flex flex-col-reverse items-start justify-end w-full gap-y-10 md:gap-0 md:flex-row '>
        <div className='flex flex-col justify-center w-[100%] sm:w-[70%] md:w-[53%] px-16 pt-28 pb-32 text-[#303030] bg-[white] items-start gap-y-4 '>
          <h1 className='text-3xl font-extrabold md:text-4xl xl:text-6xl'>My<br /><span className='relative block bottom-[11px] left-[26px]'>Vision</span></h1>
          <p className=' text-[14px] lg:text-[15px] xl:text-[17px] w-[100%] sm:w-[95%] md:w-[85%] lg:w-[80%]'>My vision is to continually evolve and become the best version of myself in the tech industry, by learning new things daily, ensuring client satisfaction, and building lasting relationships. Currently, I am improving my freelancing profiles and web development skills. Additionally, my goal is to become a motivation for beginners in the tech world.</p>
          <Link to={'/my-projects'}>
            <button className=" px-4 text-sm rounded-3xl hover:bg-black hover:text-white hover:border-white py-[13px] font-medium transition-all duration-300 text-black bg-[#fdfdfd] border-[1px] border-black " title='Explore My Projects'>
              My Projects
            </button>
          </Link>
        </div>


      </div>
    </div>
  )
}
